module.exports = __webpack_public_path__ + "img/Super380.2394ebc0.png";